export default __webpack_public_path__ + "static/media/ico-material-de.3b8c7e54.svg";